<template>
  <MainView :pose="step">
    <div class="centered">
      <div class="phone"></div>
      <div class="message">
        Please rotate your device!
      </div>
    </div>
    <el-row tag="section" id="step1">
      <el-col :span="6">
        <div class="info">
          <p class="lead">{{ messages.step1 }}</p>
          <h1>{{ messages.step1Header }}</h1>
        </div>
      </el-col>
      <el-col :span="16">
        <div class="card-deck scoping">
          <el-row type="flex" justify="space-around" class="wrap">
              <scopingDeck
                v-for="scope in industries"
                :scope="scope"
                :types="cardTypes"
                :decks="scopingCards"
                :key="scope"
                @tick="tick"
                @load="selectCard"
                @sorted="storeDecks">
              </scopingDeck>
          </el-row>
        </div>
      </el-col>
      <el-col :span="2">
      </el-col>
    </el-row>
    <el-row tag="section" id="step2">
      <el-col :span="6">
        <div class="info">
          <p class="lead">{{ messages.step2 }}</p>
          <h1>{{ messages.step2Header }}</h1>
          <refreshAll
            :types="cardTypes"
            :decks="scopingCards"
            :scope="activeScope"
            :proceed="proceed"
            @refresh="selectCard"
            @navigate="tick">
          </refreshAll>
        </div>
      </el-col>
      <el-col :span="16">
        <div class="card-deck">
          <el-row type="flex" justify="space-around" class="wrap">
            <gameCard
              v-for="(card, index) in activeCards"
              :card="card"
              :decks="scopingCards[activeScope]"
              :key="`card-${index}`"
              @refresh="selectCard">
            </gameCard>
          </el-row>
        </div>
      </el-col>
      <el-col :span="2">
        <div class="counter">
          <countContainer :pose="countdown" v-show="!proceed">
            <countChild>
              <progressRing :step="'2'" :currentStep="this.step" :showText="true" :min="0" :max="120" :value="0"></progressRing>
            </countChild>
            <countChild>
              <el-button v-show="!proceed" type="text" class="" @click="skip()">{{ messages.counterSkip }} <i class="el-icon-bottom el-icon-right"></i></el-button>
            </countChild>
          </countContainer>
          <el-button v-show="proceed && step == 2" class="el-icon-bottom clickable primary" @click="tick('down')" round></el-button>
          <el-button v-show="proceed && step == 3" class="el-icon-top clickable primary" @click="tick('up')" round></el-button>
        </div>
      </el-col>
    </el-row>
    <el-row tag="section" id="step3">
      <el-col :span="12" :offset="2">
        <div class="card-deck">
          <el-row type="flex" justify="space-around" class="wrap">
            <h1 class="m-t-3">
              {{ fullSentence }}
            </h1>
          </el-row>
        </div>
      </el-col>
      <el-col :span="10">
        <div class="info m-t-0">
          <p class="lead">{{ messages.step3 }}</p>
          <h1>{{ messages.step3Header }}</h1>
          <whatIfCard :currentStep="this.step" :header="messages.step3Header" />
        </div>
      </el-col>
    </el-row>
  </MainView>
</template>

<script>
import scopingDeck from './components/scopingDeck.vue'
import gameCard from './components/gameCard.vue'
import refreshAll from './components/refreshAll.vue'
import progressRing from './components/loader.vue'
import whatIfCard from './components/whatifCard.vue'
import axios from 'axios'
import _ from 'lodash'
import posed from 'vue-pose'

export default {
  name: 'app',
  components: { scopingDeck, gameCard, refreshAll, progressRing, whatIfCard,
      MainView: posed.div({
      label: 'main',
      '1': {
        y: 0,
        staggerChildren: 30,
        transition: { type: 'spring', stiffness: 500, damping: 100 }
      },
      '2': {
        y: - 0.85 * window.innerHeight,
        staggerChildren: 30,
        delay: 300,
        delayChildren: 300,
        transition: { type: 'spring', stiffness: 500, damping: 100 }
      },
      '3': {
        y: - 2 * 0.85 * window.innerHeight,
        staggerChildren: 30,
        transition: { type: 'spring', stiffness: 500, damping: 100 }
      }
    }),
    countContainer: posed.div({
      label: 'counter',
      'hidden': {
        opacity: 0,
      },
      'visible': {
        opacity: 1,
        transition: { duration: 150 },
        delay: 1000,
        beforeChildren: true,
        staggerChildren: 80
      },
      initialPose: 'hidden'
    }),
    countChild: posed.div({
      'hidden': { scale: 0 },
      'visible': { scale: 1 },
      initialPose: 'hidden'
    })
  },
  data() {
    return {
      industries: [],
      scopingCards: {},
      activeCards: {},
      cardTypes: [],
      activeScope: '',
      position: { x: 0, y: 0, width: 0, height: 0 },
      proceed: false,
      step: '1',
      countdown: 'hidden',
      messages: {
        'step1': 'Step 1',
        'step1Header': 'Choose your scoping deck',
        'step2': 'Step 2',
        'step2Header': 'Define your scope',
        'step3': 'Step 3',
        'step3Header': 'What if',
        'counterSkip': 'Next'
      }
    }
  },
  created() {
    let vm = this, 
      params = (new URL(document.location)).searchParams,
      gameid = params.get('id')

    vm.fetchScopes(gameid)
    vm.resize()

    window.addEventListener('resize', _.debounce(vm.resize, 250))
  },
  mounted() {
    this.$root.$on('whatif', () => {
      if (parseInt(this.step) == 2) this.toggleWhatIf()
    }),
    this.$root.$on('resetTimer', () => {
      if (parseInt(this.step) == 2) this.proceed = false
    })
    this.$root.$on('skip', () => {
      this.skip()
    })
  },
  computed: {
    width() {
      return this.position.width
    },
    height() {
      return this.position.height
    },
    fullSentence() {
      let sentence = ''
      _.each(this.activeCards, function(val) {
        sentence += val.leader + ' ' + val.title + ' '
      })
      return sentence.trim() + '?'
    }
  },
  watch: {
    width: function(a, b) {
      if (b === 0) return
      let x = this.position.x - (a - b)
      // this.tween(x, this.position.y)
      this.position.x = x
    },
    height: function(a, b) {
      if (b === 0) return
      this.position.y = this.position.y - (a - b)
    }
  },
  methods: {
    resize() {
      this.$set(this.position, 'width', window.innerWidth)
      this.$set(this.position, 'height', window.innerHeight)
    },
    fetchScopes(gameid) {
      let vm = this
      const loader = vm.$loading({ fullscreen: true })
      axios.get('/api/industries?gameid=' + encodeURIComponent(gameid))
        .then(function (response) {
          vm.industries = response.data
          return axios.get('/api/types?gameid=' + encodeURIComponent(gameid))
        })
        .then(function (response) {
          vm.cardTypes = _.sortBy(response.data.types, 'order')
          vm.whatIfs = _.shuffle(response.data.whatif)
          return axios.get('/api/localisation?gameid=' + encodeURIComponent(gameid))
        })
        .then(function (response) {
          vm.messages = response.data
        })
        .catch(function (error) {
          // add retry
          vm.industries = ['Error! Could not reach the API. ' + error]
        })
        .finally(function() {
          loader.close()
          vm.$root.$emit('loadWhatif', vm.whatIfs)
        })
    },
    storeDecks(decks, scope) {
      let vm = this
      vm.$set(vm.scopingCards, scope, decks)
    },
    toggleCountdown: _.throttle((vm) => {
      vm.countdown = 'hidden'
      setTimeout(() => {
        vm.$root.$emit('resetTimer', true, true)
        vm.countdown = 'visible'
      }, 150)
    }, 200),
    selectCard(type, cards) {
      this.toggleCountdown(this)
      let vm = this,
        l = _.size(cards.deck),
        active

      (cards.active < l-1) ? cards.active++ : cards.active = 0
      active = cards.active

      vm.setActive(cards.deck[active], cards.leader)
    },
    setActive(card, leader) {
      card.leader = leader
      this.activeScope = card.industry
      this.$set(this.activeCards, card.type, card)
    },
    tick(dir) {
      let vm = this,
        num = parseInt(vm.step)

      if(num == 2) this.countdown = 'hidden'

      switch (dir) {
        case 'down':
          num++
          vm.step = num.toString()
          break;
        case 'up':
          num--
          vm.step = num.toString()
          break;
      }
    },
    toggleWhatIf() {
      this.proceed = !this.proceed
    },
    skip() {
      if( parseInt(this.step) == 2 ) {
        this.$root.$emit('resetTimer', true, true)
        this.$root.$emit('whatif')
        this.tick('down')
      }
    }
  }
}
</script>

<style lang="scss">
  @import './assets/fonts.css';

  .lead {
    text-transform: uppercase;
  }

  body {
    margin: 0;
    position: relative;
    font-family: "SF Pro Display","SF Pro Icons","Helvetica Neue","Helvetica","Arial",sans-serif;
    overflow: hidden;
  }

  h1 {
    font-size: 3rem;
    margin-top: 0;
  }

  #app {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
  }

  .info {
    margin: 10rem 0 0 3rem;
    min-width: 12rem;
  }

  .wrap {
    flex-wrap: wrap;
  }

  .wrap:after {
    content: "";
    flex: auto;
  }

  .clickable {
    cursor: pointer;
    transition: all .2s cubic-bezier(0.57, 0.07, 0.44, 2);
  }

  .clickable:hover {
    transform: scale(1.02);
  }

  .el-row {
    padding-top: 8.5rem;
    margin-bottom: 4rem;
  }

  #step1, #step2, #step3 {
    height: 85vh;
    width: 100vw;

    &:before,
    &:after {
      background: inherit;
      content: '';
      display: block;
      height: 50%;
      left: 0;
      position: absolute;
      right: 0;
      z-index: -1;
    }

    &:before {
      top: 0;
      transform: skewY(1.5deg);
      transform-origin: 100% 0;
    }

    &:after {
      bottom: 0;
      transform: skewY(-2.5deg);
      transform-origin: 100%;
    }
  }

  #step1, #step3 {
    background-color: #ca4300;
    color: white;
  }

  .el-card {
    user-select: none;
    transition: all .2s cubic-bezier(0.57, 0.07, 0.44, 2);
  }

  .el-card:hover {
    transform: scale(1.02);
  }

  .counter {
    position: absolute;
    bottom: -3%;
    right: 3.5rem;
    display: flex;
    align-items: center;
    flex-flow: column;
  }

  .m-t-0 {
    margin-top: 0;
  }

  .m-t-3 {
    margin-top: 3rem;
  }

  .hyphenate {
    word-wrap: break-word;
    overflow-wrap: break-word;

  -webkit-hyphens: auto;
    -moz-hyphens: auto;
          hyphens: auto;
  }

  .centered {
    display: none;
    z-index: 10;
    background-color: #ca4300;
    width: 100vw;
    height: 100vh;
    flex-flow: column;
    align-items: center;
    justify-content: center;

    .phone {
      height: 3rem;
      width: 6rem;
      border: .2rem solid white;
      border-radius: 10px;
      animation: rotate 1.5s ease-in-out infinite alternate;
    }

    .message {
      color: white;
      font-size: 1.3rem;
      margin-top: 3rem;
    }
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg)
    }
    50% {
      transform: rotate(-90deg)
    }
    100% {
      transform: rotate(-90deg)
    }
  }

@media only screen and (-webkit-min-device-pixel-ratio: 1.5) and (orientation: portrait),
only screen and (-o-min-device-pixel-ratio: 3/2) and (orientation: portrait),
only screen and (min--moz-device-pixel-ratio: 1.5) and (orientation: portrait),
only screen and (min-device-pixel-ratio: 1.5) and (orientation: portrait),
only screen and (max-width: 812px) and (orientation: portrait) {
    .centered {
      display: flex;
    }
  }

  @media only screen and (max-height: 900px) {
    html {
      font-size: 15px;
    }
  }

  @media only screen and (max-height: 768px) {
    html {
      font-size: 10px;
    }

    .card-deck {
      .el-row {
        padding-top: 9.2rem;
      }
    }

    .el-row {
      padding-top: 13.5rem;
    }
  }

  @media only screen and (max-height: 600px) {
    html {
      font-size: 10px;
    }

    .card-deck {
      .el-row {
        padding-top: 8.1rem;
      }
    }

    .el-row {
      padding-top: 11.5rem;
    }
  }
</style>
